import {ZIDX} from "../standaloneLibrary.js";

export enum ContactListingAction {
    HIDE = 0,
    SAVE = 1,
    SHOW = 4,
    RECOMMENDED = 3
}

export interface ContactSaveListingParams {
    listing_unique_id: number;
    listing_index_id: number;
    listing_id: string;
    contact_x_listing_action: ContactListingAction;
}

export class ContactSaveListing {
    private static instance: ContactSaveListing;
    private zidx: ZIDX;

    private constructor(zidx: ZIDX) {
        this.zidx = zidx;
    }

    public static getInstance(zidx: ZIDX): ContactSaveListing {
        if (!ContactSaveListing.instance) {
            ContactSaveListing.instance = new ContactSaveListing(zidx);
        }
        return ContactSaveListing.instance;
    }

    public save(params: ContactSaveListingParams): Promise<boolean> {
        return this.sendRequest({
            ...params,
            contact_x_listing_action: ContactListingAction.SAVE
        });
    }

    public hide(params: ContactSaveListingParams): Promise<boolean> {
        return this.sendRequest({
            ...params,
            contact_x_listing_action: ContactListingAction.HIDE
        });
    }

    public show(params: ContactSaveListingParams): Promise<boolean> {
        return this.sendRequest({
            ...params,
            contact_x_listing_action: ContactListingAction.SHOW
        });
    }

    public parseListingId(dataId: string): { listing_index_id: number; listing_id: string } | null {
        const parts = dataId.split(":");
        if (parts.length !== 2) {
            return null;
        }
        return {
            listing_index_id: parseInt(parts[0], 10),
            listing_id: parts[1]
        };
    }

    private sendRequest(params: ContactSaveListingParams): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const postObj = {
                listing_unique_id: params.listing_unique_id,
                listing_index_id: params.listing_index_id,
                listing_id: params.listing_id,
                contact_x_listing_action: params.contact_x_listing_action,
                contact_x_listing_recommended: 0
            };

            const obj = {
                id: "contactSaveListing",
                method: "post",
                ignoreOldRequests: true,
                postObj: postObj,
                callback: (r: string) => {
                    try {
                        const rs = JSON.parse(r);
                        if (rs.success) {
                            resolve(true);
                        } else {
                            console.error("ContactSaveListing failed:", rs.errorMessage);
                            resolve(false);
                        }
                    } catch (e) {
                        console.error("ContactSaveListing parse error:", e);
                        resolve(false);
                    }
                },
                errorCallback: (r: string) => {
                    console.error("ContactSaveListing request error:", r);
                    resolve(false);
                },
                url: this.zidx.options.siteDomain + "/contact-save-listing/"
            };
            this.zidx.ajaxRequest(obj);
        });
    }
}
